<template>
    <div class="bank-account-balance-setting-form">
        <preloader :display="loading" />
        <!-- SELECT ACCOUNTS -->
        <el-form-item
            :label="
                $t.__('dashboard.forms.BankAccountBalanceSettingForm.select_account_to_display')
            "
            prop="accountsId"
        >
            <el-select
                v-model="form.accountsId"
                multiple
                :placeholder="$t.__('dashboard.forms.BankAccountBalanceSettingForm.select_account')"
                :multipleLimit="5"
                class="wp-5"
            >
                <el-option
                    v-for="account in accountsAvailable"
                    :key="account.id"
                    :label="account.label"
                    :value="account.id"
                >
                    <span class="fleft">{{ account.label }}</span>
                    <span class="fright gray-60 fs-2">
                        {{
                            $filters.numberFormatWithOptions(
                                account.balance,
                                { currencysymbol: account.currencySymbol },
                                true,
                            )
                        }}
                    </span>
                </el-option>
            </el-select>
            <p class="grey ml-1">{{ $l10n.__('5 comptes bancaires maximum') }}</p>
        </el-form-item>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';

export default {
    mixins: [SettingsFormMixin],
    data() {
        return {
            accountBalanceRules: {
                accountsId: [
                    {
                        required: true,
                        message: this.$l10n.__(
                            'Veuillez sélectionner entre 1 et 5 comptes bancaires',
                        ),
                        trigger: 'blur',
                    },
                ],
            },
            accountsAvailable: [],
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
        Promise.all([this.getBankAccount(), this.getCurrency()]).then(
            (values) => {
                this.accountsAvailable = values[0];
                const currencysArray = values[1];

                this.accountsAvailable.forEach((account) => {
                    const currency = currencysArray.find(
                        (currency) => currency['id'] == account['currencyId'],
                    );
                    account['currencySymbol'] = currency['symbol'];
                });
                this.$emit('updateLoading', { loading: false });
            },
            () => {
                this.$emit('updateLoading', { loading: false });
                Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                this.close();
            },
        );
    },
    mounted() {
        this.$emit('set-rules', this.accountBalanceRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        getCurrency() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    `/rest/currency`,
                    {},
                    (response) => {
                        response.error ? reject() : resolve(response);
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
        getBankAccount() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    `/rest/bankaccount`,
                    {},
                    (response) => {
                        response.error ? reject() : resolve(response);
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
    },
};
</script>

<style scoped lang="scss">
.bank-account-balance-setting-form {
    :deep(.el-form-item__content) {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
